// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__sDHyK","Arcade_container":"style_Arcade_container__TEFLL"};